import { Routes } from '@angular/router';
import { roleGuard } from '@rekruto/core';

/**
 * The admin IA. Two public routes — the staff sign-in and the access-denied landing — are siblings
 * of the shell, so neither ever renders admin chrome. The shell (`./shell`) is a routed layout whose
 * `<router-outlet>` hosts every in-shell page, and it carries the single `roleGuard`, so the whole
 * subtree is gated for a platform admin and a failed check redirects to the login route with the
 * deep link preserved (the core guard's `redirectTo`).
 *
 * Every in-shell route carries the `ctx` label the shell's appbar reports; `/` renders the dashboard.
 */
export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/login-page').then(m => m.LoginPage) },
  { path: 'ingen-adgang', loadComponent: () => import('./pages/access-denied-page').then(m => m.AccessDeniedPage) },
  {
    path: '',
    canActivate: [roleGuard('admin', ['/login'])],
    loadComponent: () => import('./shell').then(m => m.AdminShell),
    children: [
      { path: '', pathMatch: 'full', data: { ctx: 'Platform' }, loadComponent: () => import('./pages/dashboard-page').then(m => m.DashboardPage) },
      { path: 'tenants', data: { ctx: 'Platform, Tenants' }, loadComponent: () => import('./pages/tenants-page').then(m => m.TenantsPage) },
      { path: 'tenants/:id', data: { ctx: 'Tenant' }, loadComponent: () => import('./pages/tenant-detail-page').then(m => m.TenantDetailPage) },
      { path: 'brugere', data: { ctx: 'Platform, Brugere' }, loadComponent: () => import('./pages/users-page').then(m => m.UsersPage) },
      { path: 'roller', data: { ctx: 'Platform, Roller & rettigheder' }, loadComponent: () => import('./pages/roles-page').then(m => m.RolesPage) },
      { path: 'billing', data: { ctx: 'Platform, Billing' }, loadComponent: () => import('./pages/billing-page').then(m => m.BillingPage) },
      { path: 'ai-forbrug', data: { ctx: 'Platform, AI-forbrug' }, loadComponent: () => import('./pages/ai-usage-page').then(m => m.AiUsagePage) },
      { path: 'ai-modeller', data: { ctx: 'Platform, AI-modeller' }, loadComponent: () => import('./pages/ai-models-page').then(m => m.AiModelsPage) },
      { path: 'skills', data: { ctx: 'Platform, Skills' }, loadComponent: () => import('./pages/skills-page').then(m => m.SkillsPage) },
      { path: 'drift', data: { ctx: 'Platform, Drift' }, loadComponent: () => import('./pages/ops-page').then(m => m.OpsPage) },
      { path: 'compliance', data: { ctx: 'Platform, Compliance' }, loadComponent: () => import('./pages/compliance-page').then(m => m.CompliancePage) },
      { path: 'audit-log', data: { ctx: 'Platform, Audit-log' }, loadComponent: () => import('./pages/audit-log-page').then(m => m.AuditLogPage) },
    ],
  },
  { path: '**', redirectTo: '' },
];
